"use strict";

import { isElement, forEach } from 'lodash';

import { subscribe } from '../../01-helpers/event-manager';
import { ADD_TO_CART } from '../../02-const/event-names';
import cartCount from '../../03-api/shop/cartcount';

const moduleName = 'cart-badge',
    selectors = {
        base: `.js-${moduleName}`
    },
    className = {
        filled: 'c-link-cart--filled'
    }

export class CartBadge {
    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._config(baseElement);
        this._setup();
    }

    _updateCount() {
        const count = cartCount();

        count.then((response) => {
            this.baseElement.dataset.cartCount = response;

            if (response > 0) {
                this.baseElement.classList.add(className.filled);
            } else {
                this.baseElement.classList.remove(className.filled);
            }            
        });
    }

    _setInitialValue() {
        this._updateCount();
    }

    _bindEvents() {
        subscribe(ADD_TO_CART, () => this._updateCount());
    }

    //========= Initialization ==========//

    _config(baseElement) {
        this.baseElement = baseElement;
    }

    _setup() {
        this._bindEvents();
        this._setInitialValue();
    }

    //===================================//
}

const initCartBadge = () => {
    forEach(document.querySelectorAll(selectors.base), (baseElement) => {
        new CartBadge(baseElement);
    });
};

initCartBadge();